import { axiosInstance } from "../apiConfig";

export const createUser = async () => {
  const response = await axiosInstance.post("/api/user/register");
  return response.data;
};

export const resumeGame = async (userData) => {
  try {
    const response = await axiosInstance.post(`/api/user/resume`, userData);

    return response.data;
  } catch (error) {
    console.error("Error in resumeGame:", error);
    throw error;
  }
};

export const getMissionAccomplishments = async (userData) => {
  const response = await axiosInstance.post(
    `/api/user/accomplishments`,
    userData
  );
  return response.data;
};
